export default "<div class=\"container-modal\">\n  <app-carousel [data]=\"data\" [index]=\"index\"></app-carousel>\n</div>\n";